import Table from "react-bootstrap/Table";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

export default function AssignmentsTable({
  assignments,
  handleShowAssignmentModal,
}) {
  return (
    <>
      {assignments && assignments.length > 0 && (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>Terminal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {assignments.map((assignment, index) => (
              <tr key={index}>
                <td>
                  {assignment?.firstName} {assignment?.lastName}
                </td>
                <td>
                  {assignment?.profile?.pos_terminal
                    ? assignment?.profile?.pos_terminal?.label
                    : "None assigned"}
                </td>
                <td onClick={() => handleShowAssignmentModal(assignment)}>
                  <Button variant="link">Edit</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
}
